import React from 'react'
import { convertUTCToLocalDateTime, roundedOffPROMScore, userHasPermission } from '../../helpers/GlobalFunctions';

export default function PromSubscoreList(props) {
    const promData = { ...props.row.original };
    const subScoreList = promData.subscoreList?.length ? promData.subscoreList : [];
    return (
        <>
            <tr className="file-details-tr-text">
                <td colSpan="1"></td>
                <td colSpan="6" className="p-0">
                    <table className="proms-list proms-subscore-table table-bordered table-hover ">
                        <thead>
                            <tr className="file-details-col-heading">
                                <th colSpan="1">Entry Date / Time</th>
                                <th colSpan="1">Entry Type</th>
                                <th colSpan="1">Sub-Score Type</th>
                                <th colSpan="1">Sub-Score Value</th>
                                <th colSpan="1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {subScoreList.map((x, i) => {
                                return <>
                                    <tr className="file-details-tr-background " {...props.rowProps} key={`${props.rowProps.key}-expanded-${i}`}>
                                        <td colSpan="1">{x.uploadedDate ? convertUTCToLocalDateTime(x.uploadedDate) : 'N/A'}</td>
                                        <td colSpan="1">{x.source}</td>
                                        <td colSpan="1">{x.subScoreType}</td>
                                        <td colSpan="1">{!isNaN(parseFloat(x.score)) && x.scoreType ? roundedOffPROMScore(x.score, x.scoreType) : ''}</td>
                                        <td colSpan="1">
                                            {userHasPermission('promsUpdate') ?
                                                <>
                                                    {!(x.source === 'Aria') ?
                                                        <span title="Edit" className="cursor-pointer" onClick={() => props.enableEditProms(x)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.6em" height="1.6em" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                                <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                            </svg>
                                                        </span>
                                                        : ''}
                                                    <span className="prom-delete-icon cursor-pointer ms-2" title="Delete" onClick={() => props.showHideConfirmModal(x)}>
                                                        <svg width="1.6em" height="1.6em" viewBox="0 0 16 16" className="bi bi-trash delete-icon" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                            <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                        </svg>
                                                    </span>
                                                </>
                                                : ''}
                                        </td>
                                    </tr>
                                </>
                            })}
                        </tbody>
                    </table>
                </td>
            </tr>
        </>
    )
}
